// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__adN5E","form":"styles_form__vVOaU"};